
import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class LivestreamService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getLivestream() : Observable<any> {
    return this.http.get(this.apiService.getLivestream()).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public updateSpeech(speech) : Observable<any> {
    return this.http.put(this.apiService.updateSpeech(), {speech}).pipe(take(1),map(value => {
      return value;
    }),);
  }

}
